import {
  components,
} from '@/generated/qmulus/openapi.ts';

const maintenanceRecurrencePeriod: Record<NonNullable<components['schemas']['MaintenanceSeriesCreate']['recurrence']['period']>, string> = {
  never: 'Niemals',
  week: 'Wochen',
  month: 'Monate',
  year: 'Jahre',
};

export default {
  title: 'Wiederholung',
  repeat: 'Wiederholung',
  every: 'Alle',
  on: 'An',
  end: 'Ende',
  maintenanceRecurrencePeriod,
  selectMonths: 'Monate auswählen',
};
